import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";
import { persistAuthSession } from "utils/persistAuthSession";
import { useUrlQuery } from "hooks/useUrlQuery";

const useRegisterInstitution = () => {
	const queryClient = useQueryClient();
	const query = useUrlQuery();
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const register = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");

		const body = deleteEmptyObjects(obj);

		const formData = new FormData();
		Object.keys(body).forEach((key) => {
			formData.append(key, body[key]);
		});

		const response = await instance.post("/institutions", formData);
		return response;
	};

	return useMutation(register, {
		onSuccess: async ({ data: body }) => {
			persistAuthSession(body, { queryClient, history, intended: query.get("intended") });
		},
		onError: async ({ response }) => {
			toast.error(
				<ServerErrors
					errorMessage={"Something went wrong"}
					errors={response?.data?.data}
				/>
			);
		},
	});
};

export default useRegisterInstitution;
